export const IS_ADMIN = "is_admin";
// export const IS_FOO = "is_foo";
export const IS_AAD_USER = "is_aad_user";

export const ALL_PERMISSION_LIST = [
    IS_ADMIN,
    // IS_FOO,
];

function hasValue(obj, key, value) {
    // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
    return obj?.hasOwnProperty(key) && obj[key] === value;
}

export default function hasUserPermission(requiredRanks, userData) {
    return (
        requiredRanks.length === 0 || requiredRanks.some((rank) => hasValue(userData, rank, true))
    );
}

export function isAADUser(userData) {
    return userData.is_aad_user === true;
}
